import { render, staticRenderFns } from "./productoEditar.vue?vue&type=template&id=a7189e6a&"
import script from "./productoEditar.vue?vue&type=script&lang=js&"
export * from "./productoEditar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports